import React, { PureComponent } from "react";

class Question extends PureComponent {
  render() {
    return (
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <h6 className="question" data-toggle="collapse" data-target={"#collapse-" + this.props.keyy} aria-expanded="true" aria-controls="collapseOne">
            <i className="ion ion-md-add-circle-outline"></i>
            <span className="question-text">
            <b>Q{this.props.keyy}:</b>
              {this.props.question}
            </span>
          </h6>
          <div id={"collapse-" + this.props.keyy} className="collapse card-body" aria-labelledby="headingOne" data-parent="#faq">
            <p className="desc">{this.props.desc}</p>
            {
              this.props.desc2 ? <p className="desc">{this.props.desc2}</p> : null
            }
          </div>
        </div>
      </div >
    )
  }
}

class Faq extends PureComponent {
  render() {
    return (
      <section id="faq">
        <div className="container">
          <div className="title-block">
            <h2>Frequently Asked Questions</h2>
          </div>
          <Question
            keyy="1"
            question="Can I participate in both Beginner and Advanced training workshops?"
            desc="This is subject to vacancy, as priority will be given to participants registered in the respective categories. If there are vacancies for both training workshops, we will definitely allow you to participate in both."
            desc2="Please email ndsc@shopee.com to check for vacancies nearer to the dates of the training workshop."
          />
          <Question
            keyy="2"
            question="I am not based in Singapore during the course of the competition, can I still participate in the challenge?"
            desc="The challenge is currently only open to participants who are based in Singapore."
          />
          <Question
            keyy="3"
            question="I am based in Singapore but I will not be able to attend the opening ceremony on 23 Feb 2019, can I still take part in the competition?"
            desc="As the challenge details will only be revealed during the opening ceremony on 23 Feb 2019, we will highly encourage you to attend the opening ceremony."
            desc2="You can participate in the challenge as long as a member of your team is present for the opening ceremony. "
          />
          <Question
            keyy="4"
            question="Am I required to code in python?"
            desc="There is no restriction on the programming language."
          />
          <Question
            keyy="5"
            question="I am a tech professional but with no background in data science or I have just just graduated and joined the tech industry, can I still participate in the beginner category?"
            desc="This will be reviewed on a case-by-case basis."
          />
          <Question
            keyy="6"
            question="My team consists of both students/non-tech professionals and tech professionals. Do we sign up for the Beginner or Advanced category?"
            desc="You can sign up for either category. However, registration for the Beginner category of teams consisting of both students/non-tech professionals and tech professionals will be reviewed on a case-by-case basis. "
          />
          <Question
            keyy="7"
            question="How do I know if my registration for the NDSC is successful?"
            desc="You will receive a confirmation email in 1-2 weeks’ time after you have registered. Please reply to the confirmation email with the required information for your registration to be confirmed by 16 February 2019, 2359h."
          />
          <Question
            keyy="8"
            question="How will I be grouped if I signed up as an Individual?"
            desc="You will be assigned to a group randomly."
          />
          <Question
            keyy="9"
            question="What if I find another individual participant that I want to group with?"
            desc="If you would like to team up with another individual, please write in to ndsc@shopee.com, indicate the name and email address of the individual you want to group with and cc the individual in the email."
          />
          <Question
            keyy="10"
            question="I have been randomly allocated to a group. However, I have tried to contact them multiple times but did not receive any response. What do I do?"
            desc="You can write in to ndsc@shopee.com to request for a new group if the team members still remain unresponsive after 2 weeks."
          />
          <Question
            keyy="11"
            question="How and when will I get my $20 training workshop refund?"
            desc="The refund will be made at the Award Ceremony on 30 March 2019. Kindly present the email receipt for the refund to be made. More details on the refund will be shared via email nearer to the Award Ceremony."
          />
          <Question
            keyy="12"
            question="I am unable to access the data on Google Drive for the competition."
            desc="We have provided another set of links via dropbox. Please go to the 'Data' tab to download the data set."
          />
          <Question
            keyy="13"
            question="I have questions about the competition problem statement and the data sources."
            desc="Please submit your technical questions to the 'Discussion' tab on the Kaggle competition page so that other participants with similar issues or questions will be able to assess them. Our Admin (Data Science Team) will answer your questions as soon as possible."
            desc2="Please DO NOT send your technical enquiries to ndsc@shopee.com."
          />
          <Question
            keyy="14"
            question="What will be taken account into the final score?"
            desc="We will take into account both the submission scores and technical novelty as the final score."
            desc2="Please remember to submit the Experimental Results on Kaggle, and both the Supplementary Material and Source Code to ndsc@shopee.com by 23 March 2019, 11:59pm (SGT). More info can be found in the competition guide sent to all confirmed participants."
          />
          <Question
            keyy="15"
            question="Do I submit the deliverables individually or as a team? "
            desc="Please submit the deliverables as a team by 23 March 2019, 11.59pm (SGT)."
          />
        </div>
      </section>
    )
  }
}

export default Faq;